const init_scroll_tracking = function (steps, callback) {
  let ticking = false;
  let higest_scroll_percentage = 0;
  let scroll_steps = [];

  steps.forEach(function (i) {
    scroll_steps.push({ min: i, fired: false });
  });

  let current_step = 0;

  function get_scroll_percentage() {
    const h = document.documentElement;
    const b = document.body;
    let st = 'scrollTop';
    let sh = 'scrollHeight';
    return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
  }

  function scrolled_action() {
    if (get_scroll_percentage() > higest_scroll_percentage) {
      higest_scroll_percentage = get_scroll_percentage();
    }

    if (scroll_steps[current_step]) {
      if (
        higest_scroll_percentage >= scroll_steps[current_step].min &&
        false === scroll_steps[current_step].fired
      ) {
        scroll_steps[current_step].fired = true;

        //fire callback
        if (callback && typeof callback === 'function') {
          callback(scroll_steps[current_step].min);
        }

        current_step += 1;
      }
    }
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        scrolled_action();
        ticking = false;
      });
    }
    ticking = true;
  });
};

export { init_scroll_tracking };
